import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

interface Props {
    benifits: string[];
}

function PlanBenifitsComponent({ benifits }: Props) {
    const { t } = useTranslation();
    return (
        <div className="benifits-section">
            <h5>{t("subscriptions.whats_included")}</h5>
            {benifits.length > 0 && (
                <ul>
                    {benifits.map((item: string) => (
                        <li className="benifit-lists" key={item}>
                            {" "}
                            <FontAwesomeIcon
                                icon={faCheck}
                                size="xs"
                                style={{ color: "#000083ff" }}
                            />
                            {t(item)}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default PlanBenifitsComponent;
